(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shop-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shop-category-mega-menu')) {
    customElements.define(
      'shop-category-mega-menu',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.handleClick);
          this.addEventListener('keydown', this.handleKeydown);
          this.controlEvents = new AbortController();
          this.controlObserver = new ResizeObserver(this.queueControlUpdate);
          this.querySelectorAll('.shop-mega-menu__slideshow slideshow-slides').forEach((scroller) => {
            scroller.addEventListener('scroll', this.queueControlUpdate, { passive: true, signal: this.controlEvents.signal });
            scroller.addEventListener('scrollend', this.queueControlUpdate, { signal: this.controlEvents.signal });
            this.controlObserver.observe(scroller);
          });
          this.queueControlUpdate();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('keydown', this.handleKeydown);
          this.controlEvents?.abort();
          this.controlObserver?.disconnect();
          cancelAnimationFrame(this.controlFrame);
        }

        queueControlUpdate = () => {
          cancelAnimationFrame(this.controlFrame);
          this.controlFrame = requestAnimationFrame(() => {
            this.querySelectorAll('.shop-mega-menu__slideshow').forEach((slideshow) => {
              const scroller = slideshow.querySelector('slideshow-slides');
              if (!scroller || scroller.clientWidth === 0) return;
              const maxScroll = scroller.scrollWidth - scroller.clientWidth;
              const position = Math.abs(scroller.scrollLeft);
              const previous = slideshow.querySelector('[ref="previous"]');
              const next = slideshow.querySelector('[ref="next"]');
              const controls = slideshow.querySelector('.shop-mega-menu__controls');
              if (previous) previous.disabled = position <= 1;
              if (next) next.disabled = maxScroll - position <= 1;
              if (controls) controls.hidden = maxScroll <= 1;
            });
          });
        };

        handleClick = (event) => {
          const arrow = event.target.closest('.shop-mega-menu__controls .slideshow-control');
          if (arrow && this.contains(arrow)) {
            const slideshow = arrow.closest('.shop-mega-menu__slideshow');
            const scroller = slideshow.querySelector('slideshow-slides');
            const previous = arrow.getAttribute('ref') === 'previous';
            const remaining = previous ? Math.abs(scroller.scrollLeft) : scroller.scrollWidth - scroller.clientWidth - Math.abs(scroller.scrollLeft);
            const step = scroller.clientWidth + (parseFloat(getComputedStyle(scroller).gap) || 0);
            if (remaining <= step + 1) {
              const opposite = slideshow.querySelector(previous ? '[ref="next"]' : '[ref="previous"]');
              const focusTarget = opposite && !opposite.disabled ? opposite : this.querySelector('[data-shop-mega-tab][aria-selected="true"]');
              focusTarget?.focus();
            }
            return;
          }
          const tab = event.target.closest('[data-shop-mega-tab]');
          if (tab && this.contains(tab)) this.activateTab(tab);
        };

        handleKeydown = (event) => {
          const tabs = [...this.querySelectorAll('[data-shop-mega-tab]')];
          const currentIndex = tabs.indexOf(event.target);
          if (currentIndex < 0) return;

          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;

          event.preventDefault();
          this.activateTab(tabs[nextIndex]);
          tabs[nextIndex].focus();
        };

        activateTab(tab) {
          this.querySelectorAll('[data-shop-mega-tab]').forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
          });

          this.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
            panel.hidden = panel.id !== tab.getAttribute('aria-controls');
          });
          this.queueControlUpdate();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
